// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-view-error__actions {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.dl-view-error__btn-retry {
  margin-right: 12px;
}
.dl-view-error__actions_mobile {
  margin-top: 0;
  flex-direction: column;
  width: 100%;
}
.dl-view-error__actions_mobile .dl-view-error__btn-retry {
  margin-bottom: 16px;
  margin-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/ViewError/ViewError.scss"],"names":[],"mappings":"AAGI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAFR;AAKI;EACI,kBAAA;AAHR;AAMI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAJR;AAMQ;EACI,mBAAA;EACA,eAAA;AAJZ","sourcesContent":[".dl-view-error__actions {\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n}\n.dl-view-error__btn-retry {\n  margin-right: 12px;\n}\n.dl-view-error__actions_mobile {\n  margin-top: 0;\n  flex-direction: column;\n  width: 100%;\n}\n.dl-view-error__actions_mobile .dl-view-error__btn-retry {\n  margin-bottom: 16px;\n  margin-right: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
